define(
    "diy/undo-redo/Queue",
    function () {
        'use strict';
        var Queue;

        /**
         * @class module.undoRedo.Queue
         * @template module.undoRedo.Queue
         * @lends {module.undoRedo.Queue.prototype}
         * @constructor
         */
        Queue = Klazz.extend({

            /** @type {Array} */
            list: null,
            /** @type {Number} current execution state */
            state: null,
            /** @type {Number} locked state */
            stateLocked: 1,
            /** @type {Number} ready state */
            stateReady: 0,
            autoStart: true,
            isRunning: false,
            ignoreErrors: false,
            errors: [],

            callWhenLocked: function () {},
            callWhenReady: function () {},
            callAfterRun: function () {},

            initialize: function initialize(autoStart) {
                this.autoStart = (typeof autoStart === 'boolean') ? autoStart : true;
                this.list = [];
                this.errors = [];
                this.stateReady = 0;
                this.stateLocked = 1;
                this.state = 0;
            },

            /**
             *
             * @param {?Boolean} autoStart [default=true]
             * @returns {module.undoRedo.Queue}
             */
            setAutoStart: function setAutostart (autoStart) {
                this.autoStart = (typeof autoStart === 'boolean') ? autoStart : true;
                return this;
            },
            /**
             * will set the queue to ignore individual blocks errors if detected
             * this should not be used unless you know what you're doing
             */
            pleaseIgnoreErrors: function pleaseIgnoreErrors() {
                this.ignoreErrors = true;
            },

            /**
             *
             * @param {Function=} whenLocked called when execution is locked
             * @param {Function=} whenReady called when execution is ready
             * @param {Function=} afterRun called after execution is run and there is nothing more to run
             */
            init: function init(whenLocked, whenReady, afterRun) {

                if (typeof whenLocked === 'function') {
                    this.callWhenLocked = whenLocked;
                }
                if (typeof whenReady === 'function') {
                    this.callWhenReady = whenReady;
                }
                if (typeof afterRun === 'function') {
                    this.callAfterRun = afterRun;
                }
            },

            isReady: function isReady() {
                return this.state === this.stateReady;
            },

            lock: function lock() {
                this.state = this.stateLocked;
                return Q(this.callWhenLocked());
            },
            afterRun: function afterRun() {
                return Q(this.callAfterRun());
            },
            unlock: function unlock() {
                return Q(this.callWhenReady())
                    .then(function () {
                        this.state = this.stateReady;
                    }.bind(this));
            },

            /**
             * Alias for this.add
             *
             * @param {Function} callback
             * @param {Boolean=} autoLock [default=true]  ;
             * @returns {*}
             */
            whenReady: function whenReady(callback, autoLock) {
                return this.add(callback, autoLock);
            },

            /**
             * Adds execution items to running queue;
             * if the queue has autostart ON, it will also trigger a run
             *
             * @param {Function} callback
             * @param {Boolean=} autoLock [default=true]  ;
             */
            add: function add(callback, autoLock) {
                var lock = (typeof autoLock === 'boolean') ? autoLock : true;

                if (lock) {
                    this.list.push(
                        function () {
                            var d = Q.defer();
                            this.lock()
                                .then(function () {
                                    return Q(callback());
                                })
                                .then(this.unlock.bind(this))
                                .catch(function (error) {
                                    if (this.ignoreErrors === true) {
                                        d.resolve(error);
                                        this.errors.push(error);
                                        this.unlock.bind(this);
                                    } else {
                                        d.reject(error);
                                    }
                                }.bind(this))
                                .done(function (res) {
                                    d.resolve(res);
                                });

                            return d.promise;
                        }.bind(this)
                    );
                } else {
                    this.list.push(
                        function () {
                            return Q(callback());
                        }
                    );
                }

                if (this.autoStart === true && this.isReady() && this.isRunning === false) {
                    this.run();
                }
            },

            /**
             *
             * @param {Q.defer=} deferred
             * @returns {*}
             */
            run: function run(deferred) {
                var queue = [];
                deferred = deferred || Q.defer();

                if (this.list.length && this.isRunning === false) {
                    this.isRunning = true;
                    while (this.list.length > 0) {
                        queue.push((this.list.splice(0, 1))[0]);
                    }

                    queue.reduce(Q.when, Q(true))
                        .then(function afterRun(res) {
                            if (this.errors.length) {
                                deferred.reject(this.errors);
                                this.errors = [];
                            } else {
                                deferred.resolve(res);
                            }
                        }.bind(this))
                        .catch(function runningError(error) {
                            deferred.reject(error);
                        })
                        .done(function runDone() {
                            this.isRunning = false;
                            if (!deferred.promise.isRejected() || (deferred.promise.isRejected() && this.ignoreErrors === true)) {
                                if (this.list.length) {
                                    this.run();
                                } else {
                                    return this.afterRun();
                                }
                            } else {
                                return this.afterRun();
                            }
                        }.bind(this));
                }
                return deferred.promise;
            }
        });

        return Queue;
    }
);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/undo-redo/Queue.js
 ** module id = 919
 ** module chunks = 0
 **/